import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-viewer-root',
  standalone: false,
  templateUrl: './viewer-root.component.html',
  styleUrls: ['./viewer-root.component.scss'],
})
export class ViewerRootComponent implements OnInit, OnDestroy {
  loginDisplay = false;
  isSnapshotView = false;
  private routerEventsSub: Subscription = null;

  constructor(
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.isSnapshotView = this.router.url.startsWith('/snapshot');

    this.routerEventsSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.isSnapshotView = this.router.url.startsWith('/snapshot');
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }

  ngOnDestroy(): void {
    if (this.routerEventsSub) this.routerEventsSub.unsubscribe();
  }

  setLoginDisplay(): void {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }
}
